// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3_u27","title":"Images45_title__2SMOw","images":"Images45_images__1P1BL"};